<template>
  <div class="form-group row centix-vue-textareainput" :class="{ 'disabled' : !isEnabled }" v-show="isVisible">
    <form-label :label="label" :info="info" :labelCssClass="labelCssClass" :infoIconWrapper="infoIconWrapper"/>
    <span class="holder-span" :class="inputCssClass">
      <textarea 
        :disabled="!isEnabled" 
        ref="input" 
        type="text" 
        class="form-control input-item" 
        :class="{ filled : hasValue, required : showRequiredClass, 'user-comment-input': ShowUserComment }" 
        v-model="innervalue" 
        @input="onChange" 
        @keyup.esc="$event.target.blur()" 
        @keyup.enter="onReturn" 
        :placeholder="placeholder"
        :style="customStyle">
      </textarea>
      
      <span class="buttons">
        <span v-if="ShowUserComment" class="user-comment-button" @click="userInfoBtnClick" :title="$t('formtextareainput.timestamp')">
          <icon-base
            :view-box="'0 0 32 32'"
            :width="22"
            :height="22"
            :icon-color="'#1e88e5'">
            <generate />
          </icon-base>
        </span>
        <span v-if="showExpand" class="expand-button ml-3" @click="() => advancedSearchOpen = true" :title="$t('formtextareainput.expand')">
          <icon-base
            :view-box="'0 0 32 32'"
            :width="22"
            :height="22"
            :icon-color="'#999'">
            <expand />
          </icon-base>
        </span>
      </span>

    </span>

    <div class="model-state-error col-12">
      {{ validationError }}
    </div>

    <portal to="bottomPage">
      <!-- New FormTextAreaInput with same form properties in modal with overridden style -->
      <modal-comp v-if="advancedSearchOpen" :show-modal="advancedSearchOpen" :closeCallback="() => advancedSearchOpen = false">
        <div class="container rounded pb-2" style="background: white;">
          <component 
            v-bind="mappedProps"
            v-model="innervalue"
            :custom-style="'min-height: 80vh;'"
            :is="advancedSearchComponent"
            :show-expand="false"
            @change="onChange" />
        </div>
    </modal-comp>
    </portal>
  </div>
</template>

<script>
import FormMixin from './formitem.js';
import Utils from 'libs/utils';
import IconBase from '@/components/IconBase.vue';
import ModalComponent from '@/pages/app/MI/components/Modal.vue';

const Generate = {
  template: `<path d="M12 23c0-4.726 2.996-8.765 7.189-10.319C19.698 11.539 20 10.27 20 9c0-4.971 0-9-6-9S8 4.029 8 9c0 3.096 1.797 6.191 4 7.432v1.649c-6.784.555-12 3.888-12 7.918h12.416a10.962 10.962 0 01-.416-3z M23 14c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm5 10h-4v4h-2v-4h-4v-2h4v-4h2v4h4v2z"/>`
};
const Expand = {
  template: `<path d="M11.797 16.5a.54.54 0 01-.156.359l-5.187 5.187 2.25 2.25a.996.996 0 01.297.703c0 .547-.453 1-1 1h-7c-.547 0-1-.453-1-1v-7c0-.547.453-1 1-1a.99.99 0 01.703.297l2.25 2.25 5.187-5.187c.094-.094.234-.156.359-.156s.266.063.359.156l1.781 1.781a.536.536 0 01.156.359zM24 3v7c0 .547-.453 1-1 1a.99.99 0 01-.703-.297l-2.25-2.25-5.187 5.187c-.094.094-.234.156-.359.156s-.266-.063-.359-.156l-1.781-1.781c-.094-.094-.156-.234-.156-.359s.063-.266.156-.359l5.187-5.187-2.25-2.25a.996.996 0 01-.297-.703c0-.547.453-1 1-1h7c.547 0 1 .453 1 1z"/>`
};

const getFormTextAreaInput = () => import('./FormTextAreaInput.vue');

export default {
  mixins: [FormMixin],
  props: {
    ShowUserComment: {
      type: Boolean,
      required: false,
      default: false
    },
    showExpand: {
      type: Boolean,
      default: true
    },
    customStyle: {
    }
  },
  components: {
    'icon-base': IconBase,
    'generate': Generate,
    'expand': Expand,
    'modal-comp': ModalComponent
  },
  data () {
    return {
      formType: 'text',
      innervalue: '',
      results: [],
      selectedIndex: 0,
      hasFocus: false,
      selectedItem: null,
      isBusy: false,
      hasError: false,
      lastError: '',
      advancedSearchOpen: false,
      advancedSearchComponent: getFormTextAreaInput
    };
  },
  mounted () {
    this.innervalue = this.value;
  },
  methods: {
    clearForm: function () {
      this.$emit('change', '');
      this.emitFormChange();
    },
    onChange: function (e) {
      this.$emit('change', this.innervalue);
      this.emitFormChange();
    },
    async userInfoBtnClick (e) {
      await this.$store.dispatch('getUser');
      let user = this.$store.getters['user'];
      if (!user) return;

      let newMsg = this.innervalue || '';
      let currentDate = Utils.dateTimeToStringShort(new Date());
      let insertTag = `${user.Person_Descr} (${currentDate}) : \n`;
      newMsg = insertTag + newMsg;
      this.$emit('change', newMsg);
      this.emitFormChange();

      // Set cursor at end of new inserted tag
      this.$nextTick(() => {
        e.target.selectionEnd = insertTag.length - 1;
        e.target.selectionStart = e.target.selectionEnd;
      });
    }
  },
  watch: {
    value () {
      this.innervalue = this.value;
    }
  },
  computed: {
    hasValue: function () {
      return this.innervalue != null && this.innervalue.length > 0;
    },
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    mappedProps () {
      let copy = { ...this.$props };
      delete copy.value;
      copy.orientation = 'vertical';
      return copy;
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-vue-textareainput {
  span.holder-span {
    position: relative;
    display: block;

    textarea {
      overflow-y: scroll;
      min-height: 150px;
      width: 100% !important; //important because of Centix main.css ?
    }
  }

  &:hover {
    .clear-button {
      display: block;
    }
  }

  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid red;
      }

      &.filled {
        border: 1px solid #80bdff;
      }
    }
  }

  &.filled {
    padding-right: 28px;
  }

  .model-state-error {
    color: $error;
  }

  .buttons {
    position: absolute;
    right: 35px;
    top: 5px;
    cursor: pointer;
    .user-comment-button, .expand-button {
      cursor: pointer;
    }
  }
}



.filled.user-comment-input {
  padding-right: 60px;
}
</style>
